import ActionTypes from '../constants/ActionTypes';
import { isPageLoaded } from '../selectors/page';
import { supo } from '../api';

export const fetchPage = id => {
  return async (dispatch, getState) => {
    if (isPageLoaded(getState(), id)) return;
    try {
      dispatch({
        type: ActionTypes.FETCH_PAGE_REQUEST,
        payload: { id }
      });
      const { data } = await supo.get(`/pages/${id}`);
      return dispatch({
        type: ActionTypes.FETCH_PAGE_SUCCESS,
        payload: { id, ...data }
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return dispatch({
          type: ActionTypes.FETCH_PAGE_NOT_FOUND,
          payload: { id },
          error
        });
      }
      return dispatch({
        type: ActionTypes.FETCH_PAGE_ERROR,
        payload: { id },
        error
      });
    }
  };
};
